import { render, staticRenderFns } from "./TemplatesModal.vue?vue&type=template&id=2289fdb0&scoped=true"
import script from "./TemplatesModal.vue?vue&type=script&lang=js"
export * from "./TemplatesModal.vue?vue&type=script&lang=js"
import style0 from "./TemplatesModal.vue?vue&type=style&index=0&id=2289fdb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2289fdb0",
  null
  
)

export default component.exports